import { createBaseCRUDApi } from '@/api/base'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { PVC_URL } from './const'

export const PVС_CLIENT_URL = `${PVC_URL}-client`
const errors = createBaseResponseErrors('клиента', 'клиентов')

export const PVCClientApi = createBaseCRUDApi(PVС_CLIENT_URL, errors)
